import { Injectable } from '@angular/core';
import { FormGroup, Validators, FormBuilder, ValidatorFn, AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class FormService {
  constructor(private formBuilder: FormBuilder) { }

  affiliation = this.formBuilder.group({
    name: ['', Validators.required],
    formattedAddress: ['', Validators.required],
    phone: [''],
    email: [
      '',
      [
        Validators.required,
        Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
      ],
    ],
    companyWebsite: [
      '',
      [
        Validators.required,
        Validators.pattern(
          '^[-a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)$'
        ),
      ],
    ]
  });
}
